export type OrderTableKey = 'platform' | 'package' | 'initialDate' | 'finalDate' | 'adhesionStatus';

export type OrderTableItem = Record<OrderTableKey, string>;

export type OrderTableWidthCols = Record<OrderTableKey, number>;

export const tableHead: OrderTableItem = {
  platform: 'Nome ferramenta',
  package: 'Pacote',
  initialDate: 'Data início',
  finalDate: 'Data fim',
  adhesionStatus: 'Situação Adesão',
};

export const desktopWidthCols: OrderTableWidthCols = {
  platform: 20,
  package: 15,
  initialDate: 20,
  finalDate: 20,
  adhesionStatus: 25,
};

export const tabletWidthCols: OrderTableWidthCols = {
  platform: 20,
  package: 15,
  initialDate: 20,
  finalDate: 20,
  adhesionStatus: 25,
};

export const desktopMaxHeight = 550;
